<div class="ticket-create-container">
  <div class="row mb-3 align-items-center">
    <div class="col-12">
      <button nbButton ghost size="small" (click)="goBack()" class="mb-2">
        <nb-icon icon="arrow-back-outline"></nb-icon> Back to Support
      </button>
      <h3 class="mb-0">Create Support Ticket</h3>
    </div>
  </div>

  <nb-card>
    <nb-card-body>
      <form [formGroup]="ticketForm" (ngSubmit)="onSubmit()">

        <!-- Subject -->
        <div class="form-group mb-3">
          <label class="form-label">Subject <span class="text-danger">*</span></label>
          <input
            nbInput
            fullWidth
            formControlName="subject"
            placeholder="Brief description of your issue"
          />
          <div class="text-danger small mt-1"
               *ngIf="ticketForm.get('subject')?.invalid && ticketForm.get('subject')?.touched">
            Subject is required.
          </div>
        </div>

        <!-- Category -->
        <div class="form-group mb-3">
          <label class="form-label">Category</label>
          <nb-select formControlName="category" fullWidth>
            <nb-option value="general">General</nb-option>
            <nb-option value="technical">Technical</nb-option>
            <nb-option value="billing">Billing</nb-option>
            <nb-option value="account">Account</nb-option>
          </nb-select>
        </div>

        <!-- Priority -->
        <div class="form-group mb-3">
          <label class="form-label">Priority</label>
          <nb-select formControlName="priority" fullWidth>
            <nb-option value="low">Low</nb-option>
            <nb-option value="normal">Normal</nb-option>
            <nb-option value="high">High</nb-option>
            <nb-option value="urgent">Urgent</nb-option>
          </nb-select>
        </div>

        <!-- Description -->
        <div class="form-group mb-3">
          <label class="form-label">Description <span class="text-danger">*</span></label>
          <textarea
            nbInput
            fullWidth
            formControlName="description"
            rows="6"
            placeholder="Please describe your issue in detail..."
          ></textarea>
          <div class="text-danger small mt-1"
               *ngIf="ticketForm.get('description')?.invalid && ticketForm.get('description')?.touched">
            Description is required.
          </div>
        </div>

        <!-- File Attachments -->
        <div class="form-group mb-3">
          <label class="form-label">Attachments</label>
          <div>
            <input
              type="file"
              #fileInput
              multiple
              style="display: none;"
              (change)="onFileSelect($event)"
            />
            <button type="button" nbButton outline size="small" (click)="fileInput.click()">
              <nb-icon icon="attach-outline"></nb-icon> Add Files
            </button>
            <small class="text-muted ms-2">Max 5 files, 10 MB each</small>
          </div>

          <div *ngIf="attachmentError" class="text-danger small mt-1">{{ attachmentError }}</div>

          <ul class="attachment-list mt-2" *ngIf="attachments.length > 0">
            <li *ngFor="let file of attachments; let i = index" class="attachment-item">
              <nb-icon icon="file-outline" class="me-1"></nb-icon>
              <span class="attachment-name">{{ file.name }}</span>
              <span class="attachment-size text-muted ms-1">({{ formatFileSize(file.size) }})</span>
              <button type="button" nbButton ghost size="tiny" status="danger" (click)="removeAttachment(i)" class="ms-2">
                <nb-icon icon="close-outline"></nb-icon>
              </button>
            </li>
          </ul>
        </div>

        <!-- Submit -->
        <div class="d-flex gap-2">
          <button
            type="submit"
            nbButton
            status="primary"
            [disabled]="loading"
          >
            <nb-icon icon="paper-plane-outline" *ngIf="!loading"></nb-icon>
            {{ loading ? 'Submitting...' : 'Submit Ticket' }}
          </button>
          <button type="button" nbButton ghost (click)="goBack()" [disabled]="loading">
            Cancel
          </button>
        </div>

      </form>
    </nb-card-body>
  </nb-card>
</div>
